import { createAsyncThunk } from '@reduxjs/toolkit'
import ProfileMediaPreferences from './profile-media-preferences-model'
import {
  delete_profileMediaPreferences,
  load_profileMediaPreferencess,
  store_profileMediaPreferences,
} from './profileMediaPreferences-service'

export const LoadProfileMediaPreferencessAsync = createAsyncThunk<any, any>(
  'composer/load/profileMediaPreferences',
  async (params: { uid: string }) => {
    return await load_profileMediaPreferencess(params)
  },
)

export const CreateProfileMediaPreferencesAsync = createAsyncThunk<any, any>(
  'composer/create/profileMediaPreferences',
  async (params: ProfileMediaPreferences) => {
    return await store_profileMediaPreferences(params)
  },
)

export const DeleteProfileMediaPreferencesAsync = createAsyncThunk<any, any>(
  'composer/delete/profileMediaPreferences',
  async (params) => {
    return await delete_profileMediaPreferences(params)
  },
)
